import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import { gsap } from "gsap";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const name = location.state?.name || "";
  const cardRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
    tl.fromTo(
      cardRef.current,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 0.8 },
    ).fromTo(
      iconRef.current,
      { scale: 0, opacity: 0 },
      { scale: 1, opacity: 1, duration: 0.5 },
      "-=0.4",
    );
  }, []);

  return (
    <Page>
      <Card ref={cardRef}>
        <Icon ref={iconRef}>✓</Icon>
        <Title>Faleminderit{name ? `, ${name}` : ""}!</Title>
        <Subtitle>Porosia juaj u pranua me sukses.</Subtitle>
        <Body>
          Do t'ju kontaktojmë së shpejti për të konfirmuar detajet e dërgesës.
          Nëse keni pyetje, na kontaktoni në Instagram{" "}
          <strong>@siarabeautyks</strong>.
        </Body>
        <Details>
          <DetailItem>
            <DetailIcon>📦</DetailIcon>
            <DetailText>Porosia përpunohet brenda 24 orëve</DetailText>
          </DetailItem>
          <DetailItem>
            <DetailIcon>🚚</DetailIcon>
            <DetailText>Dërgesa bëhet brenda 2–4 ditëve pune</DetailText>
          </DetailItem>
          <DetailItem>
            <DetailIcon>💳</DetailIcon>
            <DetailText>Pagesa me dorëzim (cash on delivery)</DetailText>
          </DetailItem>
        </Details>
        <HomeBtn onClick={() => navigate("/")}>
          ← Kthehu në faqen kryesore
        </HomeBtn>
      </Card>
    </Page>
  );
};

const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(160deg, #fdf8f5 0%, #fceee8 60%, #f7e0d5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.4rem;
`;

const Card = styled.div`
  background: white;
  border-radius: 24px;
  padding: 3.5rem 3rem;
  max-width: 520px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(180, 120, 100, 0.1);
`;

const Icon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--dark);
  color: var(--cream);
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.6rem;
`;

const Title = styled.h1`
  font-family: var(--serif);
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 300;
  color: var(--dark);
  margin-bottom: 0.5rem;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-family: var(--sans);
  font-size: 1rem;
  font-weight: 400;
  color: var(--gold);
  letter-spacing: 0.05em;
  margin-bottom: 1.2rem;
`;

const Body = styled.p`
  font-family: var(--sans);
  font-size: 0.88rem;
  font-weight: 300;
  line-height: 1.75;
  color: var(--mid);
  margin-bottom: 2rem;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  background: linear-gradient(135deg, #fdf8f5, #fceee8);
  border-radius: 14px;
  padding: 1.4rem 1.6rem;
  margin-bottom: 2rem;
  text-align: left;
`;

const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

const DetailIcon = styled.span`
  font-size: 1rem;
  flex-shrink: 0;
`;

const DetailText = styled.p`
  font-family: var(--sans);
  font-size: 0.82rem;
  font-weight: 300;
  color: var(--mid);
`;

const HomeBtn = styled.button`
  font-family: var(--sans);
  font-size: 0.78rem;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--mid);
  background: transparent;
  border: 1px solid var(--rose);
  border-radius: 100px;
  padding: 0.8rem 2rem;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    border-color: var(--dusty);
    color: var(--dark);
  }
`;

export default ThankYou;
